import { render, staticRenderFns } from "./coachOrderList.vue?vue&type=template&id=6987c05b&scoped=true"
import script from "./coachOrderList.vue?vue&type=script&lang=ts"
export * from "./coachOrderList.vue?vue&type=script&lang=ts"
import style0 from "./coachOrderList.vue?vue&type=style&index=0&id=6987c05b&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6987c05b",
  null
  
)

export default component.exports